import { render, staticRenderFns } from "./ConoceZona.vue?vue&type=template&id=4e04a6aa"
import script from "./ConoceZona.vue?vue&type=script&lang=js"
export * from "./ConoceZona.vue?vue&type=script&lang=js"
import style0 from "./ConoceZona.vue?vue&type=style&index=0&id=4e04a6aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports